module.exports = __webpack_public_path__ + "img/car.5b3ddac4.svg";